/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:20
 * @LastEditTime: 2019-10-22 17:18:55
 * @LastEditors: Please set LastEditors
 */
import axios from "axios";
import qs from "qs";
axios.defaults.timeout = 500000;
axios.defaults.withCredentials = true;
//http request 拦截器

axios.interceptors.request.use(
  (config) => {
    config.data = qs.stringify(config.data);
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    };
    if (process.env.VUE_APP_type == "development") {
      localStorage.setItem(
        "access_tokens",
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6IjgzZGM4ZTI2NDBlMjNkNDVhNGI2YzU3ODNhZGM5NDZkY2JlOTg2NTAzYzY1NGE0ZWI2NDhkNWVlOTk1ODkzZmQ1MDA5ZDRlMjk4NDJiNDQ0In0.eyJhdWQiOiIxMDA4ODAwMyIsImp0aSI6IjgzZGM4ZTI2NDBlMjNkNDVhNGI2YzU3ODNhZGM5NDZkY2JlOTg2NTAzYzY1NGE0ZWI2NDhkNWVlOTk1ODkzZmQ1MDA5ZDRlMjk4NDJiNDQ0IiwiaWF0IjoxNzc5OTU4MzgxLCJuYmYiOjE3Nzk5NTgzODEsImV4cCI6MTc4MTI1NDM4MSwic3ViIjoiMSIsInNjb3BlcyI6WyIqIl19.upIuTcsz7Nyo-w0_Zb8Pdt5bh2jTydRfKx2kezXI-wFmYuWJkqQNBd-UR1w26wiB4KYtG1xaywv7sLxHBQyeWrddUGDatRdaUBkAQzei3HAmLYS0tt8NkdPGsp5tk1gR-S5HC6_s707SCvkZZx5iNArjhdzKcPLESAJEvnweSWFsgPpFzinyKTMMTdN3TarQUOUZrxo7djBMAAOGviTb8CnGnyIm38FZl1O_6NqysmfMa93-3wjug6WsMFGb7VVYNyG03PwnU2xQJ8z7ssAocnBe6GLgHkh43gGrrqmB-up4hMLsB6mf7bG-u_D3_1vVNdYeHd61bKK1mEPuHG5i5Twg0ruWUorUXgWBiarLBn12khVVQRQK1sl_jzHKfY4sjY7T3Z7eSjp6ddQ54Nb1s2YLde39AsgaF6ehG9raZbEV_OGLtxrbHuS7aDLTovWltFYrdzxcQ7tzEEWs9bTE2lrZM-Jne6do-CvlIFX218sLP7MgJ7wlvEBIR7C_l4ieNePWXyAcj2uBDForUSWfG6u9aZxPTojyuGv6YspEAN2Sq8L0BuuYhribwdd6-qk9dcAWQafFYKkejdYpZrHM22Qs4ojQg-OXSzaovLh3YxZa6aGykKkiWVch4FUCjwfUIcEGP_JVTszkjz7_uGiJfZKhiO9c_7tl_IAqOZ1VOhc"
      );
    }
    config.headers.Authorization =
      "Bearer" + " " + localStorage.getItem("access_tokens");
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
//http response 拦截器
axios.interceptors.response.use(
  (response) => {
    if (response.data.code == 100) {
      location.href = location.href.split("#/")[0] + "#/login"; //跳回登陆页面
    }
    return response;
  },
  (error) => {
    if (error.data) {
      return Promise.reject(error.data);
    } else {
      return Promise.reject(error.response.data);
    }
  }
);

//定义全局的api
let api;

if (process.env.VUE_APP_type == "development") {
  api = {
    logistics: "http://znwl.com/admin/v2",
    logistics_2: "http://pps.qwe.com/index.php/",
    pda: "http://znwl.com/pda/v2/",
  };
  api = {
    logistics: "https://logistics.tx315.vip/admin/v2",
    // logistics: "http://znwl.com/admin/v2",
    logistics_2: "https://pps.tx315.vip/index.php/",
    pda: "https://logistics.tx315.vip/pda/v2/",
    // pda: "http://znwl.com/pda/v2/",
  };
} else if (process.env.VUE_APP_type == "production") {
  api = {
    logistics: "https://logistics.tx315.vip/admin/v2",
    logistics_2: "https://pps.tx315.vip/index.php/",
    pda: "https://logistics.tx315.vip/pda/v2/",
  };
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
export function fetch (module, url, params = {}) {
  let baseUrl = "";
  if (module == "logistics") {
    baseUrl = api.logistics + url;
  } else if (module == "logistics_2") {
    baseUrl = api.logistics_2 + url;
  } else if (module == "pda") {
    baseUrl = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios
      .get(baseUrl, {
        params: params,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post (module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch (module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put (module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function del (module, url, data = {}) {
  if (module == "logistics") {
    url = api.logistics + url;
  } else if (module == "logistics_2") {
    url = api.logistics_2 + url;
  } else if (module == "pda") {
    url = api.pda + url;
  }
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
